import React, { Component, Fragment } from "react";
import { Grid, Typography, TextField, Button, Paper, MenuItem, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import MainContainer from "../../components/MainContainer";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import StateTable from "./StateTable";
import UserTable from "./UserTable";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import Heading from "../../components/Heading";
import { ProfileType, OrganisationType } from "../../types/enum";
import { Prompt } from "react-router-dom";
import agent from "../../agent";
import OrganisationEmbedWidget from "../../components/widget/OrganisationEmbedWidget";

import Loading from "../../components/loadingSpinner/Loading";

const HOT_PINK = "#fe0d9d";

const EMPLOYER_OPTIONS = [
    {
        value: "group",
        label: "Group Employer",
        icon: "🏢",
        tooltip: "One employer record and one subscription covers all venues in your group. Best for centralised payroll management.",
        accentColor: HOT_PINK,
    },
    {
        value: "per-venue",
        label: "Per-Venue Employer",
        icon: "🏪",
        tooltip: "Each venue manages its own employer record and subscription independently. Best for venues with separate operations.",
        accentColor: HOT_PINK,
    },
];

@inject("organisationStore", "organisationMemberStore", "stateStore", "profileStore", "templateStore", "billingStore", "userStore", "embedGigStore")
@observer
class OrganisationEdit extends Component {
    state = {
        isLoading: false,
        initialEmployerModel: null,
        confirmModelOpen: false,
        pendingModelChoice: null,
    };

    constructor(props) {
        super(props);
        this.props.organisationMemberStore.reset();
        this.props.stateStore.reset();
        this.props.organisationStore.resetSelection();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.templateStore.openOrganisationBlock();
        if (this.props.match.params.id) {
            this.setState(
                {
                    ...this.state,
                    isLoading: true
                },
                () => {
                    this.props.organisationStore.load(this.props.match.params.id).then(org => {
                        this.props.organisationMemberStore.setMembers(org.members);
                        this.props.organisationMemberStore.setOrganisationId(org.id);
                        this.props.organisationMemberStore.setLevel(1);
                        this.props.stateStore.setStates(org.state);
                        
                        this.setState({
                            ...this.state,
                            isLoading: false,
                            // Capture the server-saved value so we can distinguish
                            // "never set" (warn on first selection) from "already set" (lock).
                            initialEmployerModel: this.props.organisationStore.employerModel || null,
                        });
                    });
                }
            );
        } else {
            this.props.organisationStore.setupNew();
        }
    }

    handleNameChange = e => {
        this.props.organisationStore.setName(e.target.value);
        this.props.templateStore.closeOrganisationBlock();
    };
    handleAddressChange = e => {
        this.props.organisationStore.setAddress(e.target.value);
        this.props.templateStore.closeOrganisationBlock();
    };
    handleContactNumberChange = e => {
        this.props.organisationStore.setContactNumber(e.target.value.replace(/\D/,''));
        this.props.templateStore.closeOrganisationBlock();
    };
    handleLevel1LabelChange = e => {
        this.props.organisationStore.setLevel1Label(e.target.value);
        this.props.templateStore.closeOrganisationBlock();
    };
    handleLevel2LabelChange = e => {
        this.props.organisationStore.setLevel2Label(e.target.value);
        this.props.templateStore.closeOrganisationBlock();
    };
    handleLevel3LabelChange = e => {
        this.props.organisationStore.setLevel3Label(e.target.value);
        this.props.templateStore.closeOrganisationBlock();
    };

    handleSubmitForm = async(e) => {
        e.preventDefault();
        this.setState({
            ...this.state,
            isLoading: true
        });
        const { level1Label } = this.props.organisationStore;
        const { currentUser } = this.props.userStore;
        const { currentProfile } = this.props.profileStore;

        if (!this.props.match.params.id) {
            switch (currentProfile.type) {
                case ProfileType.Staff.ordinal:
                    this.props.organisationStore.setType(OrganisationType.Venue.ordinal);
                    break;
                case ProfileType.Agent.ordinal:
                    this.props.organisationStore.setType(OrganisationType.Agency.ordinal);
                    break;
                default:
                    break;
            }
        }
        
        if (this.props.match.path === "/organisation/new") {
            if(currentProfile.type == ProfileType.Staff.ordinal){
                let candidateCustomer = { 
                    userId: currentUser.sub, 
                    email: currentUser.email, 
                    given_name: currentUser.given_name, 
                    family_name: currentUser.family_name, 
                    userType: 4
                };
                var customer = await agent.Billing.createCustomer(candidateCustomer);
                if(customer){
                    this.props.organisationStore.submit().then((org) => {
                        Promise.all([
                            this.props.profileStore.loadProfilesAfterLogin(),
                            this.props.userStore.pullUser()
                        ]).then(() => { 
                            this.setState({
                                ...this.state,
                                isLoading: false
                            });
                          
                            
                            this.props.templateStore.openSnackbar(`${level1Label} updated`);
                            this.props.templateStore.openOrganisationBlock();
                            if (!this.props.match.params.id) {
                                this.props.history.push(`/organisation`);
                            }
                        });
                    });
                }
                
               
            }
        }else{
            this.props.organisationStore.submit().then((org) => {
                this.setState({
                    ...this.state,
                    isLoading: false
                });
              
                
                this.props.templateStore.openSnackbar(`${level1Label} updated`);
                this.props.templateStore.openOrganisationBlock();
                if (!this.props.match.params.id) {
                    this.props.history.push(`/organisation`);
                }
            });
        }

        // submit
       
    };

    anyError(field) {
        if (!this.props.organisationStore.errors) return false;
        if (!this.props.organisationStore.errors[field]) return false;
        return true;
    }

    errorText(field) {
        if (!this.props.organisationStore.errors) return null;
        if (!this.props.organisationStore.errors[field]) return null;
        return this.props.organisationStore.errors[field];
    }

    handleClick = () => {
        this.setState({ open: true });
    };

    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({ open: false });
    };

    handleCurrencyChange = e => {
        this.props.organisationStore.setCurrency(e.target.value);
    }

    handleSelectEmployerModel = (model) => {
        this.props.organisationStore.setEmployerModel(model);
        this.props.templateStore.closeOrganisationBlock();
    };

    renderHgSuperPaySection() {
        const { id, employerModel } = this.props.organisationStore;
        const canManage = this.props.organisationStore.canManage || id === undefined;
        const { initialEmployerModel } = this.state;

        // Once a model has been saved to the server, cards are locked.
        // For brand-new orgs (no id), always allow free selection — nothing is saved yet.
        const isLocked = !!id && !!initialEmployerModel;
        // For existing orgs with no saved model, warn before the first commit.
        const requiresWarning = !!id && !initialEmployerModel;

        return (
            <Grid item xs={12}>
                <div style={{ paddingTop: 8, paddingBottom: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12 }}>
                        <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#333", fontSize: 15 }}>HG Super Pay</Typography>
                        <Tooltip title="Choose how superannuation is managed across your venue group. Australian customers only." placement="right">
                            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 16, height: 16, borderRadius: "50%", background: "#e5e7eb", color: "#6b7280", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0 }}>?</span>
                        </Tooltip>
                    </div>
                        <Grid container spacing={16}>
                            {EMPLOYER_OPTIONS.map(opt => {
                                const isSelected = employerModel === opt.value;
                                const cardClickable = !isLocked && canManage;
                                const handleClick = () => {
                                    if (!cardClickable) return;
                                    if (requiresWarning) {
                                        this.setState({ confirmModelOpen: true, pendingModelChoice: opt.value });
                                    } else {
                                        this.handleSelectEmployerModel(opt.value);
                                    }
                                };
                                return (
                                    <Grid item xs={12} md={6} key={opt.value}>
                                        <div
                                            onClick={handleClick}
                                            style={{
                                                border: `2px solid ${isLocked ? "#eee" : isSelected ? opt.accentColor : "#eee"}`,
                                                borderRadius: 10,
                                                padding: "18px 20px",
                                                cursor: cardClickable ? "pointer" : "default",
                                                background: isLocked
                                                    ? (isSelected ? "#f5f5f5" : "#fafafa")
                                                    : (isSelected ? `${opt.accentColor}08` : "#fff"),
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: 14,
                                                transition: "border-color 0.15s, background 0.15s",
                                                boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                                                position: "relative",
                                                opacity: isLocked && !isSelected ? 0.5 : 1,
                                            }}
                                        >
                                            <span style={{ fontSize: 26, flexShrink: 0, marginTop: 2 }}>{opt.icon}</span>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                                                    <span style={{ fontWeight: 700, fontSize: 14, color: isLocked ? "#888" : (isSelected ? opt.accentColor : "#333") }}>
                                                        {opt.label}
                                                    </span>
                                                    <Tooltip title={opt.tooltip} placement="top">
                                                        <span style={{
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: 16,
                                                            height: 16,
                                                            borderRadius: "50%",
                                                            background: "#e5e7eb",
                                                            color: "#6b7280",
                                                            fontSize: 10,
                                                            fontWeight: 700,
                                                            cursor: "help",
                                                            flexShrink: 0,
                                                        }}>
                                                            ?
                                                        </span>
                                                    </Tooltip>
                                                </div>
                                                <div style={{ fontSize: 12.5, color: "#888", lineHeight: 1.5 }}>
                                                    {opt.value === "group"
                                                        ? "One employer record covers all venues."
                                                        : "Each venue has its own employer record."}
                                                </div>
                                            </div>
                                            {isSelected && (
                                                <span style={{
                                                    position: "absolute",
                                                    top: 10,
                                                    right: 12,
                                                    width: 20,
                                                    height: 20,
                                                    borderRadius: "50%",
                                                    background: isLocked ? "#aaa" : opt.accentColor,
                                                    color: "#fff",
                                                    fontSize: 11,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontWeight: 700,
                                                }}>
                                                    ✓
                                                </span>
                                            )}
                                        </div>
                                    </Grid>
                                );
                            })}
                        </Grid>
                        {isLocked && (
                            <div style={{ marginTop: 10, fontSize: 12, color: "#aaa" }}>
                                To change this, contact{" "}
                                <a href="mailto:support@hotgiggity.com" style={{ color: "#aaa" }}>
                                    support@hotgiggity.com
                                </a>
                            </div>
                        )}
                        {employerModel && id && (
                            <div style={{ marginTop: 14 }}>
                                <a
                                    href={`/organisation/${id}/hg-super-pay`}
                                    style={{ color: HOT_PINK, fontWeight: 600, fontSize: 13, textDecoration: "none" }}
                                >
                                    Manage HG Super Pay →
                                </a>
                            </div>
                        )}
                    </div>
            </Grid>
        );
    }

    render() {
        const { name, address, contactNumber, level1Label, level2Label, level3Label, id, currency } = this.props.organisationStore;
        const { currentProfile } = this.props.profileStore;
        const { organisationBlock } = this.props.templateStore;
        const breadcrumb = [
            { name: "Dashboard", link: "/staff" },
            { name: "Organisation", link: "/organisation" },
            { name: this.props.organisationStore.name }
        ];

        var canManage = this.props.organisationStore.canManage || id === undefined;
        return (
            <Fragment>
            <main>
                <Prompt
                    when={organisationBlock}
                    message={location => `You have unsaved Organisation data, do you still want to leave this section?`}
                />
                <Header userRole="agent" />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={breadcrumb} />
                    <Heading title={this.props.match.params.id ? "Edit Organisation" : "Create Organisation"} />

                    <div style={{ position: "relative" }}>
                        <Loading showed={this.state.isLoading} />
                        <Paper>
                            <form onSubmit={this.handleSubmitForm} className="org-form">
                                <Grid container spacing={16}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                                                    <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#333", fontSize: 15 }}>{level1Label}</Typography>
                                                    <Tooltip title="Manage your venues in a hierarchical structure. Group venues into 3 levels, each with its own users and permissions." placement="right">
                                                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 16, height: 16, borderRadius: "50%", background: "#e5e7eb", color: "#6b7280", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0 }}>?</span>
                                                    </Tooltip>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <TextField
                                                    id="org-name"
                                                    label={`${level1Label} Name`}
                                                    fullWidth
                                                    value={name}
                                                    onChange={this.handleNameChange}
                                                    error={this.anyError("name")}
                                                    helperText={this.errorText("name")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <TextField
                                                    id="org-address"
                                                    label="Address"
                                                    fullWidth
                                                    value={address}
                                                    onChange={this.handleAddressChange}
                                                    error={this.anyError("address")}
                                                    helperText={this.errorText("address")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    id="org-contactNumber"
                                                    label="Contact Number"
                                                    fullWidth
                                                    value={contactNumber}
                                                    onChange={this.handleContactNumberChange}
                                                    error={this.anyError("contactNumber")}
                                                    helperText={this.errorText("contactNumber")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    id="currency"
                                                    label="Currency"
                                                    select
                                                    margin="dense"
                                                    fullWidth
                                                    value={currency ?? "AUD"}
                                                    onChange={this.handleCurrencyChange}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                >
                                                    <MenuItem value="AUD">AUD</MenuItem>
                                                    <MenuItem value="USD">USD</MenuItem>
                                                    <MenuItem value="GBP">GBP</MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {/* HG Super Pay — AUD only */}
                                    {(currency ?? "AUD") === "AUD" && id && this.renderHgSuperPaySection()}

                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                                                    <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#333", fontSize: 15 }}>Hierarchy Labels</Typography>
                                                    <Tooltip title="Customise the display names for each level of your organisation hierarchy to match your business structure." placement="right">
                                                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 16, height: 16, borderRadius: "50%", background: "#e5e7eb", color: "#6b7280", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0 }}>?</span>
                                                    </Tooltip>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    id="org-level1Label"
                                                    label="Level 1 Label"
                                                    fullWidth
                                                    value={level1Label}
                                                    onChange={this.handleLevel1LabelChange}
                                                    error={this.anyError("level1Label")}
                                                    helperText={this.errorText("level1Label")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    id="org-level2Label"
                                                    label="Level 2 Label"
                                                    fullWidth
                                                    value={level2Label}
                                                    onChange={this.handleLevel2LabelChange}
                                                    error={this.anyError("level2Label")}
                                                    helperText={this.errorText("level2Label")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    id="org-level3Label"
                                                    label="Level 3 Label"
                                                    fullWidth
                                                    value={level3Label}
                                                    onChange={this.handleLevel3LabelChange}
                                                    error={this.anyError("level3Label")}
                                                    helperText={this.errorText("level3Label")}
                                                    InputProps={{
                                                        readOnly: !canManage
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <UserTable level={1} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <StateTable />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {this.props.match.params.id && (
                                        <Fragment>
                                            <Grid item xs={12}>
                                                <Grid container spacing={8}>
                                                    <Grid item xs={12}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                                                            <Typography variant="subtitle1" style={{ fontWeight: 700, color: "#333", fontSize: 15 }}>Embed Widget</Typography>
                                                            <Tooltip title="Copy this embed code to display upcoming gigs from this organisation on any website. Use the Customise button to adjust colours and layout." placement="right">
                                                                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 16, height: 16, borderRadius: "50%", background: "#e5e7eb", color: "#6b7280", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0 }}>?</span>
                                                            </Tooltip>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <OrganisationEmbedWidget organisationId={this.props.match.params.id} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Fragment>
                                    )}
                                    {currentProfile && (
                                        <Grid item xs={12}>
                                            <div className="action">
                                                <Button component={Link} to="/organisation">
                                                    Back
                                                </Button>
                                                &nbsp;
                                                {canManage ? (
                                                    <Button variant="contained" color="primary" type="submit" id="organisation-submit">
                                                        Save
                                                    </Button>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </form>
                        </Paper>
                    </div>
                </MainContainer>
            </main>

            {/* One-time warning dialog for first employer model selection on an existing org */}
            <Dialog
                open={this.state.confirmModelOpen}
                onClose={() => this.setState({ confirmModelOpen: false, pendingModelChoice: null })}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle style={{ backgroundColor: HOT_PINK, padding: "12px 24px" }} disableTypography>
                    <Typography variant="title" style={{ color: "#fff", fontWeight: 700 }}>
                        Are you sure?
                    </Typography>
                </DialogTitle>
                <DialogContent style={{ paddingTop: 20 }}>
                    <DialogContentText>
                        You are choosing <strong>
                            {this.state.pendingModelChoice === "group" ? "Group Employer" : "Per-Venue Employer"}
                        </strong> as your employer model.
                    </DialogContentText>
                    <DialogContentText style={{ marginTop: 12 }}>
                        ⚠️ <strong>This can only be done once.</strong> Once confirmed, you will need to contact{" "}
                        <a href="mailto:support@hotgiggity.com" style={{ color: HOT_PINK }}>
                            support@hotgiggity.com
                        </a>{" "}
                        to make any changes.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: "12px 20px" }}>
                    <Button
                        onClick={() => this.setState({ confirmModelOpen: false, pendingModelChoice: null })}
                        style={{ color: "#888" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            const choice = this.state.pendingModelChoice;
                            this.setState({ confirmModelOpen: false, pendingModelChoice: null });
                            this.handleSelectEmployerModel(choice);
                        }}
                        style={{ backgroundColor: HOT_PINK, color: "#fff", fontWeight: 700 }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            </Fragment>
        );
    }
}
export default OrganisationEdit;
